var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { useQuery } from "@tanstack/react-query";
import { profileDetailsCacheKey, profileScopeCacheKey } from "../api/cacheKeys.js";
import queryFnFactory from "./query.js";
function useProfileQuery({
  config,
  keyProps,
  queryOptions = {}
}) {
  return useQuery(__spreadValues({
    queryKey: profileDetailsCacheKey(keyProps),
    queryFn: queryFnFactory(config, keyProps)
  }, queryOptions));
}
function useProfileScopeQuery({
  config,
  keyProps,
  queryOptions = {}
}) {
  const headers = {
    "X-syf-Expect": "100-continue",
    "X-syf-Unmasked-Data": "true"
  };
  return useQuery(__spreadValues({
    queryKey: profileScopeCacheKey(keyProps),
    queryFn: queryFnFactory(config, keyProps, headers)
  }, queryOptions));
}
export { useProfileQuery, useProfileScopeQuery };
//# sourceMappingURL=profileQuery.js.map
